import React, { useCallback, useEffect, useRef, useState } from "react";
import s from "./style.module.scss";
import AvatarPlaceholder from "./icons/AvatarPlaceholder";
import SecondaryInput from "shared/ui/SecondaryInput";
import Select from "shared/ui/Select";
import { selectValues } from "./consts";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import Button from "shared/ui/Button";
import { api_key } from "shared/api/consts";
import { mallSelect } from "shared/redux/selectors/mall";
import { EditProfileApi } from "./api";
import { showError } from "shared/lib/showError";
import { fetchUserInfo } from "shared/redux/asyncActions/fetchUserInfo";
import { ISelectItem } from "shared/ui/Select/types";

const EditProfileForm: React.FC = () => {
  const dispatch = useAppDispatch();

  const { user_info, auth_key } = useAppSelector(userSelect);
  const { id } = useAppSelector(mallSelect);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("...");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState<ISelectItem>();
  const [birth, setBirth] = useState("");

  const [avatar, setAvatar] = useState<File | null>(null);
  const [avatarPreview, setAvatarPreview] = useState<any>(null);

  const [dataSending, setDataSending] = useState(false);

  useEffect(() => {
    if (user_info) {
      if (user_info.fullname) setName(user_info.fullname);
      if (user_info.msisdn) setPhone(`+7${user_info.msisdn}`);
      if (user_info.email) setEmail(user_info.email);
      if (user_info.gender) {
        selectValues.forEach((item) => {
          if (item.id === user_info.gender) setGender(item);
        });
      }
      if (user_info.birthday) {
        const [year, month, day] = user_info.birthday.split("-");
        setBirth(`${day}.${month}.${year}`);
      }
    }
  }, [user_info]);

  const handleImageUpload = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let reader = new FileReader();
      //@ts-ignore
      let file = (e.target as HTMLInputElement).files[0];

      reader.onloadend = () => {
        setAvatar(file);
        setAvatarPreview(reader.result);

        //@ts-ignore
        fileInputRef.current.value = null;
      };

      reader.readAsDataURL(file);
    },
    [avatar, avatarPreview]
  );

  const handleSave = () => {
    setDataSending(true);

    const data = new FormData();

    const [day, month, year] = birth.split(".");
    const formattedDate = `${year}-${month}-${day}`;

    // 2003-04-10
    data.append("user_id", String(user_info?.id));
    data.append("auth_key", auth_key!);
    data.append("api_key", api_key!);
    data.append("mall_id", String(id!));
    if (name) data.append("fullname", name);
    if (email) data.append("email", email);
    if (gender) data.append("gender", String(gender.id));
    if (birth) data.append("birthday", formattedDate);
    if (avatar) data.append("image", avatar);

    EditProfileApi(data)
      .then((res) => {
        dispatch(
          fetchUserInfo({ auth_key: auth_key!, user_id: user_info?.id! })
        );
      })
      .catch((e) => showError(e, dispatch))
      .finally(() => setDataSending(false));
  };

  return (
    <form className={s.form}>
      <label className={s.avatar} htmlFor="avatar">
        <input
          ref={fileInputRef}
          onChange={handleImageUpload}
          type="file"
          id="avatar"
        />

        <div className={s.image}>
          {avatarPreview ? (
            <img src={avatarPreview} alt="Avatar" />
          ) : user_info?.avatar ? (
            <img src={user_info.avatar} alt="Avatar" />
          ) : (
            <AvatarPlaceholder />
          )}
        </div>

        <div className={s.text}>Добавить фото</div>
      </label>

      <SecondaryInput
        id="name"
        label="Ваше имя"
        mask={String}
        setValue={setName}
        value={name}
      />

      <SecondaryInput
        id="phone"
        label="Телефон"
        mask={String}
        setValue={setPhone}
        value={phone}
        disabled
      />

      <SecondaryInput
        id="email"
        label="E-mail"
        mask={String}
        setValue={setEmail}
        value={email}
      />

      <Select
        label="Пол"
        selectValues={selectValues}
        setValue={setGender}
        value={gender}
      />

      <SecondaryInput
        id="birth"
        label="День рождения"
        placeholder="дд.мм.гггг"
        mask={"00.00.0000"}
        setValue={setBirth}
        value={birth}
      />

      <Button className={s.button} onClick={handleSave} disabled={dataSending}>
        Сохранить
      </Button>
    </form>
  );
};

export default EditProfileForm;
